import type { PositionRow } from '@/components/finest-custom-position-list/types'

const EMPTY = '—'

export function cellNumber(row: PositionRow, key: string): number | null {
  return typeof row.cells[key] === 'number' ? (row.cells[key] as number) : null
}

export function formatMoney(value: number | null, locale: string): string {
  return value === null ? EMPTY : `${new Intl.NumberFormat(locale, { maximumFractionDigits: 0 }).format(value)} €`
}
